import {Button} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import * as dotProp from 'dot-prop';
import produce from 'immer';
import React, {useEffect, useState} from 'react';
import {
  emptyEntityTag,
  EntityWithTags,
  IEntityTagContainer,
} from '../../../../CommonInterfaces/EntityTag';
import {FormHeading} from '../../../Typography/FormHeading';
import {FullWidthDivider} from '../../../Typography/FullWidthDivider';
import {useStyles} from './styles';

interface IEntityTag {
  name: string
  formik: any,
}

export const entityTagsArrayToObject = (data: any) => {
  if (data && Array.isArray(data.tags)) {
    const ETObject: IEntityTagContainer = {};
    for (let i = 0; i < data.tags.length; i++) {
      ETObject[i] = data.tags[i];
    }
    if (Object.keys(ETObject).length === 0) {
      ETObject[0] = emptyEntityTag;
    }
    data.tags = ETObject;
  }
  return data;
};

export const removeLastEmptyEntityTag = (data: any) => {
  const keys = Object.keys(data.tags);
  const key: number = keys.pop() as unknown as number;

  const elToRemove = data.tags[key];

  if (elToRemove && elToRemove.name === '') {
    return produce(data, (draft: EntityWithTags) => {
      delete draft.tags[key];
    });
  }
  return data;
};

export const EntityTag = ({
  name,
  formik,
}: IEntityTag) => {
  const [rows, setRows] = useState<any>([]);
  const [values, setValues] = useState<IEntityTagContainer>({});
  const [errors, setErrors] = useState<any>([]);

  const addPair = () => {
    const newEl = produce(values, (draft: IEntityTagContainer) => {
      const key: number = parseInt(Object.keys(draft).pop() as string);
      const newKey = key + 1;
      draft[newKey] = emptyEntityTag;
    });
    formik.setFieldValue(name, newEl, false);
    setValues(newEl);
  };

  useEffect(() => {

    setValues(formik.values[name]);
    setErrors(formik.errors[name]);
  }, [formik.values[name], formik.errors[name]]);

  useEffect(() => {
    const lastEl = values[Object.keys(values).pop() as unknown as number];
    if ((lastEl && lastEl.name !== '')) {
      addPair();
    }

    let i = -1;
    const rows = Object.keys(values).map((el) => {
      i++;
      const deleteHandler = (i: number) => {
        let newEl: IEntityTagContainer;
        newEl = produce(values, (draft) => {
          delete draft[i];
        });

        if (Object.keys(newEl).length === 0) {
          newEl = {};
          newEl[0] = emptyEntityTag;
        }

        formik.setFieldValue(name, newEl, false);
        setValues(newEl);
      };

      return <TagRow name={name} formik={formik}
        index={el as unknown as number}
        onDelete={deleteHandler}
        key={el}/>;
    });
    setRows(rows);
  }, [values, errors]);

  return (
    <React.Fragment>
      <FullWidthDivider/>
      <FormHeading title={'Метки'}/>
      {rows}
    </React.Fragment>
  );

};

interface ITagRow {
  formik: any
  name: string
  index: number
  onDelete: any
}

const TagRow = ({
  formik,
  name,
  index,
  onDelete,
}: ITagRow) => {
  const tagName = `${name}[${index}].name`;
  const tagDot = `${name}.${index}.name`;

  const tagError = dotProp.get(formik.errors, tagDot) as string[];
  const tagTouched = dotProp.get(formik.touched, tagDot) as boolean;

  const deleteHandler = () => {
    onDelete(index);
  };

  const value = (dotProp.get(formik.values, tagDot) !== undefined) ?
    dotProp.get(formik.values, tagDot) :
    '';
  return (
    <React.Fragment>
      <TextField
        value={value}
        fullWidth
        id={tagName}
        name={tagName}
        label={'Название'}
        onChange={formik.handleChange}
        error={tagTouched && Boolean(tagError)}
        helperText={tagTouched && tagError}
      />
      <Button
        className={useStyles().deleteButton} onClick={deleteHandler}
        variant="outlined" fullWidth type="button">
        Удалить
      </Button>
      <FullWidthDivider/>
    </React.Fragment>
  );
};
